<template>
  <body>
    <div class="myPost_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back"> 나의 댓글 <span id="thehae">{{ commentCnt }}</span></h1>
      </div>
      <div class="div_padding"></div>
      <!-- board_list -->
      <div class="reply_list" v-for="(comment, idx) in commentList" :key="comment.commentId" @click="moveToCmView(comment.boardId, comment.nttId)">
        <p>{{ comment.nttSj }}</p>
        <div class="reply">
          <p>{{ comment.commentContent }}</p>
        </div>
        <div class="writer">
          <span class="like" v-if="comment.likeYn == 'N'">
            <i class="far fa-heart"></i> {{ comment.likeCnt }}
          </span>
          <span class="like ed" v-else>
            <i class="fas fa-heart"></i> {{ comment.likeCnt }}
          </span>
          <span>
            {{ comment.viewDate }}
          </span>
          <span>
            <img src="images/basic/icon/trash.svg" alt="" @click.stop="delelteMyComment(comment.boardId, comment.nttId, comment.commentId, idx)">
          </span>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import { fetchMyCommentList, deleteComment } from '@/api/boards'
export default {
  data() {
    return {
      pageIndex: 1,
      commentCnt: 0,
      commentList: [],
      listLength: 8,
    }
  },
  mounted() {
    var offset = 10;
    window.addEventListener('scroll', () => { // scroll event 등록
        if(window.$(window).scrollTop() > ( window.$(document).height() - window.$(window).height()) - offset){
            this.fetchData();
        }
    });
  },
  created() {
    fetchMyCommentList({
      pageIndex: this.pageIndex,
      recordCntOnPage: this.listLength
    })
    .then(({ data }) => {
      this.commentCnt = data.resultCnt;
      this.commentList = data.resultList;
    })
  },
  methods: {
    moveToCmView(boardId, nttId) {
      this.$router.push({
         path: '/community_view', query: {
              boardId,
              nttId
         }
     })
    },
    fetchData() {
      if(this.commentCnt > this.listLength) {
        this.pageIndex += 1
        fetchMyCommentList({
          pageIndex: this.pageIndex,
          recordCntOnPage: 8
        })
        .then(({ data }) => {
           this.commentList = [...this.commentList, ...data.resultList]
           this.listLength += 8
        })
        // if(this.commentCnt - this.listLength > 8) {
        //   this.pageIndex = this.listLength + 1;
        //   fetchMyCommentList({

        //     pageIndex: this.pageIndex,
        //     recordCntOnPage: 8,
        //   })
        //   .then(({ data }) => {
        //     console.log(data);
        //     this.commentList = [...this.commentList, ...data.resultList]
        //     this.listLength += 8
        //   })
        // } else {
        //   let extra = this.commentCnt - this.listLength;
        //   this.pageIndex = this.listLength + 1;
        //   fetchMyCommentList({

        //     pageIndex: this.pageIndex,
        //     recordCntOnPage: extra,
        //   })
        //   .then(({ data }) => {
        //     console.log(data);
        //     this.commentList = [...this.commentList, ...data.resultList]
        //     this.listLength += extra
        //   })
        // }
      }
    },
    delelteMyComment(boardId, nttId, commentId, idx) {
      deleteComment({
        boardId,
        nttId,
        commentId
      })
      .then((res) => {
      
        this.commentList.splice(idx, 1);
        this.commentCnt -= 1;
      })
      .catch((err) => {
        console.log(err);
      })
    }
  },

}
</script>

<style>

</style>